import { Avatar, Box, Chip, Typography } from "@mui/material";
import ImageLoader from "../components/ImageLoader";

const Details = ({ data }) => {
  const imageSource = data?.imagen || data?.img;

  const fullName = [
    data?.nombre,
    data?.apellido_paterno,
    data?.apellido_materno,
  ]
    .filter(Boolean)
    .join(" ");

  const specialty = data?.especialidad || "Especialidad no disponible";

  const capitalizeWords = (text = "") => {
    if (!text) return "";
    return String(text)
      .toLowerCase()
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };
  const university =
    data?.centro_estudios ||
    data?.universidad ||
    "Centro de estudios no disponible";

  const cedula = data?.cedula || "No disponible";

  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        {/* FOTO */}
        <Box sx={styles.imageContainer}>
          {imageSource ? (
            <ImageLoader
              src={imageSource}
              alt={fullName}
              width="100%"
              height="100%"
            />
          ) : (
            <Avatar sx={styles.avatar}>{fullName?.charAt(0)}</Avatar>
          )}
        </Box>
        {/* NOMBRE */}
        <Typography sx={styles.name}>{fullName}</Typography>
        {/* ESPECIALIDAD */}
        <Chip label={specialty} sx={styles.specialty} />
        {/* CÉDULA */}
        <Box mt={1}>
          <Typography sx={styles.value}>{cedula}</Typography>
          <Typography sx={styles.label}>CÉDULA PROFESIONAL</Typography>
        </Box>
        {/* UNIVERSIDAD */}
        <Box mt={1}>
          <Typography sx={styles.value}>
            {capitalizeWords(university)}
          </Typography>
          <Typography sx={styles.label}>CENTRO DE ESTUDIOS</Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default Details;

const styles = {
  container: {
    background: "linear-gradient(180deg,#123055 0%, #102948 100%)",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    padding: {
      xs: 1,
      md: 2,
    },
  },
  content: {
    width: "100%",
    maxWidth: 370,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    paddingTop: 10,
  },
  imageContainer: {
    width: 220,
    height: 220,
    borderRadius: 10,
    overflow: "hidden",
    border: "2px solid rgba(255,255,255,.15)",
    background: "#243047",
    boxShadow: "0 12px 35px rgba(0,0,0,.30)",
    mb: 5,
  },
  avatar: {
    width: "100%",
    height: "100%",
    fontSize: 70,
    bgcolor: "#34557C",
  },
  name: {
    color: "#FFFFFF",
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 800,
    fontSize: {
      xs: 22,
      md: 23,
    },
    lineHeight: 1.05,
    mb: 1,
  },

  specialty: {
    background: "#2B91AA",
    color: "#FFF",
    fontSize: 14,
    borderRadius: 10,
    height: 34,
    "& .MuiChip-label": {
      px: 2,
    },
  },
  label: {
    color: "#5EA9D6",
    fontSize: 10,
    letterSpacing: 1,
    fontWeight: 700,
    fontFamily: "Plus Jakarta Sans",
    mb: 1,
  },
  value: {
    color: "#FFF",
    fontSize: 20,
    fontWeight: 700,
    fontFamily: "Plus Jakarta Sans",
  },
};
